(function () {
    'use strict';

    angular.module("imApp").factory("offDutyCodeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 489,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 490,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 579,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
